import { useEffect, RefObject } from 'react'
import { useRouter } from 'next/router'

const useScrollToTop = (
  scrollContainerRef?: RefObject<HTMLElement>,
  dependency?: any,
  { alsoScrollWindow = false }: { alsoScrollWindow?: boolean } = {}
) => {
  const router = useRouter()

  useEffect(() => {
    // Only run on client side to avoid SSR issues
    if (typeof window === 'undefined') return

    // Use requestAnimationFrame to ensure the new content has rendered
    // before scrolling, preventing the scroll from firing before
    // the DOM updates (which can cause it to not reach the top)
    const rafId = requestAnimationFrame(() => {
      if (scrollContainerRef?.current) {
        scrollContainerRef.current.scrollTo({ top: 0, behavior: 'instant' })
      }
      if (!scrollContainerRef?.current || alsoScrollWindow) {
        window.scrollTo({ top: 0, behavior: 'instant' })
      }
    })

    return () => cancelAnimationFrame(rafId)
  }, [router.asPath, scrollContainerRef, dependency, alsoScrollWindow]) // Re-run when route changes or dependency changes
}

export default useScrollToTop
